module.exports = __webpack_public_path__ + "28eaa033217bb1d835561681d95b1147.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000C7J.png
// module id = 1571
// module chunks = 0